<script>
import BaseNumber from '@components/_base-number.vue'

export default {
  components: { BaseNumber },
  props: {
    report: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    conversion() {
      return this.report.configuration.conversion
    },
    shouldShowWebsiteReferralConversions() {
      return (
        this.conversion.websiteReferrals.active === true &&
        !this.conversion.pageViews.active
      )
    },
    shouldShowPageViewConversions() {
      return this.conversion.pageViews.active === true
    },
    shouldUseCompanySizeConversion() {
      return this.conversion.companySize.active === true
    },
    websiteReferralConversion() {
      if (!this.conversion.websiteReferrals.active) {
        return 0
      }
      return (
        ((this.report.data.events.websiteReferrals || 0) +
          (this.report.data.events.instagramReferrals || 0)) *
        (this.conversion.websiteReferrals.value / 100)
      )
    },
    pageViewConversion() {
      if (!this.conversion.pageViews.active) {
        return 0
      }
      return (
        this.report.data.pageViews * (this.conversion.pageViews.value / 100)
      )
    },
    companySize() {
      return this.conversion.companySize.value
    },
    convertedGuestsWebsiteReferrals() {
      return this.websiteReferralConversion * this.companySize
    },
    convertedGuestsPageViews() {
      return this.pageViewConversion * this.companySize
    },
    totalConversions() {
      return (
        (this.pageViewConversion || 0) + (this.websiteReferralConversion || 0)
      )
    },
    convertedGuests() {
      return Math.round(this.totalConversions) * this.companySize
    },
    hasMoreStatistics() {
      return (
        this.report.data.events.profileVisits || this.report.data.events.phone
      )
    },
    shouldShowConversion() {
      return (
        this.shouldShowWebsiteReferralConversions ||
        this.shouldShowPageViewConversions
      )
    },
  },
}
</script>
<template>
  <div>
    <ul :class="$style.list">
      <i18n path="summary.page_views" tag="li"
        ><BaseNumber :number="report.data.pageViews"
      /></i18n>
      <i18n
        v-if="shouldShowWebsiteReferralConversions"
        path="summary.total_referrals"
        tag="li"
        ><BaseNumber
          :number="
            (report.data.events.websiteReferrals || 0) +
              (report.data.events.instagramReferrals || 0)
          "
          :decimals="0"
      /></i18n>
      <i18n
        v-if="shouldShowConversion"
        :path="
          shouldUseCompanySizeConversion
            ? 'summary.visitor_conversion'
            : 'summary.visitor_total'
        "
        tag="li"
        ><BaseNumber :number="totalConversions" :decimals="0"
      /></i18n>
      <i18n
        v-if="shouldUseCompanySizeConversion"
        path="summary.visitor_company"
        tag="li"
        ><BaseNumber :number="companySize" :decimals="1"
      /></i18n>
      <i18n
        v-if="shouldUseCompanySizeConversion"
        path="summary.visitor_total"
        tag="li"
        ><BaseNumber :number="convertedGuests" :decimals="0"
      /></i18n>
    </ul>
    <ul v-if="hasMoreStatistics" :class="$style.sublist">
      <li>{{ $t('summary.more_statistics') }}</li>
      <i18n
        v-if="report.data.events.websiteReferrals"
        path="summary.website_referrals"
        tag="li"
        ><BaseNumber :number="report.data.events.websiteReferrals" :decimals="0"
      /></i18n>
      <i18n
        v-if="report.data.events.instagramReferrals"
        path="summary.instagram_referrals"
        tag="li"
        ><BaseNumber
          :number="report.data.events.instagramReferrals"
          :decimals="0"
      /></i18n>
      <i18n
        v-if="report.data.events.profileVisits"
        path="summary.profile_visits"
        tag="li"
        ><BaseNumber :number="report.data.events.profileVisits" :decimals="0"
      /></i18n>
      <i18n v-if="report.data.events.phone" path="summary.phone_number" tag="li"
        ><BaseNumber :number="report.data.events.phone" :decimals="0"
      /></i18n>
    </ul>
  </div>
</template>
<style lang="scss" module>
@import '@design';
.list {
  li {
    @extend %typography-large;
  }
}
.sublist {
  li {
    @extend %typography-medium;
  }
}
</style>
